import { render, staticRenderFns } from "./NotificationTaskExpires.vue?vue&type=template&id=30c50bfc&scoped=true&lang=pug&"
import script from "./NotificationTaskExpires.vue?vue&type=script&lang=js&"
export * from "./NotificationTaskExpires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c50bfc",
  null
  
)

export default component.exports